<span [innerHTML]="shortText()"></span>
@if (tooLong()) {
  <button (click)="openModal()" motifButton color="link-alt">
    <motif-icon [iconFunction]="icon" />
  </button>
}
